/**
 * Accessibility plugin for Tabs
 *
 * based over:
 * Bootstrap: tab.js v3.3.7
 * http://getbootstrap.com/javascript/#tabs
 */
/*eslint-disable*/
+(function ($) {
    'use strict';

    // save original
    var _BS_original_Tab_prototype_activate = $.fn.tab.Constructor.prototype.activate;

    $.fn.tab.Constructor.prototype.activate = function (element, container, callback) {
        // save active now - what was active, same as BS plugin
        var $active = container.find('> .active');
        var transition =
            callback &&
            $.support.transition &&
            (($active.length && $active.hasClass('fade')) || !!container.find('> .fade').length);

        // call original
        _BS_original_Tab_prototype_activate.apply(this, arguments);

        function next() {
            $active
                .find('[data-toggle="tab"]')
                .attr({
                    'aria-selected': false,
                    tabindex: '-1',
                })
                .removeAttr('aria-expanded');

            element
                .filter(':not([role="tabpanel"])')
                .find('[data-toggle="tab"]')
                .attr({
                    'aria-selected': true,
                    tabindex: '0',
                })
                .removeAttr('aria-expanded');

            $active.filter('[role="tabpanel"]').removeAttr('tabindex').attr('aria-hidden', true);

            element
                .filter('[role="tabpanel"]')
                .attr({
                    tabindex: '0',
                    'aria-hidden': false,
                })
                // nested tabs
                .find('.active [data-toggle="tab"]')
                .attr({
                    'aria-selected': true,
                    tabindex: '0',
                })
                .end()
                .find('[data-toggle="tab"]')
                .removeAttr('aria-expanded');
        }

        $active.length && transition ? $active.one('bsTransitionEnd', next) : next();
    };

    /**
     * Key handler for tabs
     * @param {Event} event
     * @return boolean
     */
    var _handleKeyPress = function (event) {
        var keyCodes,
            currentIndex = null;
        keyCodes = {
            DOWN: 40,
            END: 35,
            HOME: 36,
            LEFT: 37,
            RIGHT: 39,
            UP: 38,
        };

        // do nothing for not allowed keys
        if (!(Object.values(keyCodes).indexOf(event.keyCode) > -1)) return;

        var $this = $(this);
        var $ul = $this.closest('ul:not(.dropdown-menu)');
        var $li = $this.parent('li');
        var $list = $ul.find('li');

        currentIndex = $li.index();
        var prevIndex = currentIndex;
        var tabCount = $list.length;

        var reverse = false;

        // reverse order
        if ($li.css('direction') === 'rtl') {
            reverse = true;
        }

        function prev() {
            currentIndex--;
            if (currentIndex < 0) {
                currentIndex = tabCount - 1;
            }
        }

        function next() {
            currentIndex++;
            if (currentIndex >= tabCount) {
                currentIndex = 0;
            }
        }

        function end() {
            currentIndex = tabCount - 1;
        }

        function home() {
            currentIndex = 0;
        }

        switch (event.keyCode) {
            case keyCodes.LEFT:
            case keyCodes.UP:
                if (reverse) {
                    next();
                } else {
                    prev();
                }
                break;
            case keyCodes.END:
                if (reverse) {
                    home();
                } else {
                    end();
                }

                break;
            case keyCodes.HOME:
                if (reverse) {
                    end();
                } else {
                    home();
                }
                break;
            case keyCodes.RIGHT:
            case keyCodes.DOWN:
                if (reverse) {
                    prev();
                } else {
                    next();
                }
                break;
            default:
                currentIndex = null;
        }

        if (currentIndex !== null && prevIndex !== currentIndex) {
            $list.eq(currentIndex).find('[data-toggle="tab"], [data-toggle="pill"]').focus().tab('show');
        }

        // stop page from scrolling, while we handle navigation in tabs
        return false;
    };

    var _prepareTabAccessibility = function () {
        $('[data-toggle="tab"]')
            .attr({
                'aria-selected': 'false',
            })
            .removeAttr('aria-expanded')
            .parents('.active')
            .find('[data-toggle="tab"]')
            .attr({
                'aria-selected': true,
                tabindex: '0',
            })
            .removeAttr('aria-expanded');

        $('[role="tabpanel"]').attr('aria-hidden', true);
        $('[role="tabpanel"]').filter('.active').attr('aria-hidden', false);
    };

    var _removeTabAriaHidden = function () {
        $('[role="tabpanel"]').attr('aria-hidden', true);
        $('[role="tabpanel"]').filter('.active').attr('aria-hidden', false);
    };

    $(document)
        .on('keydown.bs.tab.data-api', '[data-toggle="tab"]', _handleKeyPress)
        .on('keydown.bs.tab.data-api', '[data-toggle="pill"]', _handleKeyPress);

    // prepare accessibility state
    $(document).ready(_prepareTabAccessibility);
    $(document).on('init.bs.tab', _prepareTabAccessibility);
    $(document).on('shown.bs.tab', _removeTabAriaHidden);
})(jQuery);
